import moment from 'moment';
import { openPrintWindow, escapeHtml } from '../MedicineOrders/printDispenseAuthorization';
import { buildMinistryPrintHtml } from '../../Shared/printLayout';

function fmtDate(v) {
    if (!v) return '—';
    try { return moment(v).format('YYYY/MM/DD HH:mm'); } catch { return '—'; }
}

export function buildSurplusRequestHtml(detail) {
    const approvals = (detail.approvals || []).map((row, index) => `
        <tr class="${index % 2 === 0 ? 'bg-gray-striped-1' : 'bg-gray-striped-2'}"><td>${index + 1}</td><td>${Number(row.stepNo || index + 1)}</td><td>${escapeHtml(row.requiredRoleLabel || row.requiredRole || '—')}</td><td>${escapeHtml(row.decisionLabel || '—')}</td><td>${escapeHtml(row.note || '—')}</td></tr>
    `).join('');

    const infoHtml = `
        <div class="col-6">
          <table class="table table-sm table-bordered mb-2 meta-table">
            <tbody>
              <tr class="bg-gray-striped-1"><th>الصنف</th><td>${escapeHtml(detail.productName || '—')}</td></tr>
              <tr class="bg-gray-striped-2"><th>المرفق</th><td>${escapeHtml(detail.branchName || '—')}</td></tr>
              <tr class="bg-gray-striped-1"><th>الكمية</th><td>${Number(detail.quantity || 0)}</td></tr>
              <tr class="bg-gray-striped-2"><th>الحالة</th><td>${escapeHtml(detail.statusLabel || '—')}</td></tr>
            </tbody>
          </table>
        </div>
        <div class="col-6">
          <table class="table table-sm table-bordered mb-2 meta-table">
            <tbody>
              <tr class="bg-gray-striped-1"><th>الملاحظة</th><td>${escapeHtml(detail.note || '—')}</td></tr>
              <tr class="bg-gray-striped-2"><th>قرار الإدارة</th><td>${escapeHtml(detail.adminDecisionNote || '—')}</td></tr>
              <tr class="bg-gray-striped-1"><th>المرفق المستهدف</th><td>${escapeHtml(detail.targetBranchName || '—')}</td></tr>
              <tr class="bg-gray-striped-2"><th>تاريخ الإنشاء</th><td>${escapeHtml(fmtDate(detail.createdOn))}</td></tr>
              <tr class="bg-gray-striped-1"><th>تاريخ القرار</th><td>${escapeHtml(fmtDate(detail.decidedOn))}</td></tr>
            </tbody>
          </table>
        </div>`;

    const bodyHtml = `
      <div class="section-title">مسار الاعتماد</div>
      <table class="table table-sm table-bordered text-center align-middle">
        <thead>
          <tr class="bg-gray"><th>#</th><th>الخطوة</th><th>الدور</th><th>القرار</th><th>الملاحظة</th></tr>
        </thead>
        <tbody>${approvals || '<tr><td colspan="5" class="text-center">لا توجد بيانات اعتماد</td></tr>'}</tbody>
      </table>`;

    const signaturesHtml = `
        <div class="col-4"><p><strong>المرفق المبلغ</strong><br/>الاسم: ............................<br/>التوقيع: ............................</p></div>
        <div class="col-4"><p><strong>اعتماد الجهة المختصة</strong><br/>الاسم: ............................<br/>التوقيع والختم: ............................</p></div>
        <div class="col-4"><p><strong>الختم الرسمي</strong><br/>الاسم: ............................<br/>التوقيع: ............................</p></div>`;

    return buildMinistryPrintHtml({
        title: 'طلب فائض وتوجيه للتدوير',
        docRef: detail.code || detail.id || detail.productName || '',
        infoHtml,
        bodyHtml,
        signaturesHtml,
        footerSummary: 'وثيقة فائض تُستخدم لإثبات توفر أصناف زائدة واقتراح إعادة توجيهها أو تدويرها حسب قرار الإدارة المختصة.',
        footerMeta: `مرجع الطلب: <strong>${escapeHtml(detail.code || String(detail.id || ''))}</strong>`
    });
}

export function printSurplusRequest(detail) {
    return openPrintWindow(buildSurplusRequestHtml(detail));
}
